import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-black shadow-md rounded-lg mt-24 mb-16">
      <h1 className="text-3xl font-bold mb-4 text-white">Privacy Policy</h1>
      <p className="text-sm text-gray-400 mb-6">
        <strong>Last Updated:</strong> July 14, 2025
      </p>

      <section className="mb-6">
        <p className="text-white leading-relaxed">
          At HumanAI Ventures Inc ("we," "us," or "our"), your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you visit our website <a href="https://www.humanaiinc.com" className="text-pink-400 hover:text-pink-300 underline">https://www.humanaiinc.com</a>.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3 text-white">1. Information We Collect</h2>
        <p className="text-white leading-relaxed mb-3">
          We collect personal information that you voluntarily provide—currently limited to your email address when you sign up for updates, newsletters, or early access.
        </p>
        <p className="text-white leading-relaxed">
          We do not collect sensitive personal information, nor do we knowingly collect data from children under 13.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3 text-white">2. How We Use Your Information</h2>
        <p className="text-white leading-relaxed mb-3">
          We use your email address to:
        </p>
        <ul className="list-disc list-inside text-white leading-relaxed space-y-2 ml-4">
          <li>Send product updates, newsletters, or early access opportunities</li>
          <li>Respond to inquiries or support requests</li>
          <li>Improve our offerings based on interest and engagement</li>
        </ul>
        <p className="text-white leading-relaxed mt-3">
          We will never sell your information to any third parties.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3 text-white">3. Cookies & Analytics</h2>
        <p className="text-white leading-relaxed mb-3">
          Our website may use basic cookies or third-party tools (such as Google Analytics) to help us analyze site traffic and improve functionality. These tools may collect browser-based data (like IP address or device type), but do not personally identify you.
        </p>
        <p className="text-white leading-relaxed">
          You can control cookie settings at any time through your browser preferences.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3 text-white">4. Your Rights (California Residents)</h2>
        <p className="text-white leading-relaxed mb-3">
          If you are a California resident, you have rights under the California Consumer Privacy Act (CCPA), including:
        </p>
        <ul className="list-disc list-inside text-white leading-relaxed space-y-2 ml-4">
          <li>The right to know what personal data we collect and how we use it</li>
          <li>The right to request access to or deletion of your data</li>
          <li>The right to opt out of any future sale of personal information (we do not sell personal data)</li>
        </ul>
        <p className="text-white leading-relaxed mt-3">
          To make a request, email us at <a href="mailto:hello@humanaiinc.com" className="text-pink-400 hover:text-pink-300 underline">hello@humanaiinc.com</a>.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3 text-white">5. Data Retention</h2>
        <p className="text-white leading-relaxed">
          We retain your email address until you unsubscribe or request deletion. You can unsubscribe at any time by clicking the unsubscribe link in our emails or contacting us directly.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3 text-white">6. Changes to This Policy</h2>
        <p className="text-white leading-relaxed">
          We may update this Privacy Policy from time to time. Any significant changes will be posted here, along with an updated "Last Updated" date.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-3 text-white">7. Contact Us</h2>
        <p className="text-white leading-relaxed mb-3">
          If you have any questions or concerns about this Privacy Policy, please contact us at:
        </p>
        <address className="not-italic text-white leading-relaxed">
          <strong>HumanAI Inc</strong><br />
          Email: <a href="mailto:hello@humanaiinc.com" className="text-pink-400 hover:text-pink-300 underline">hello@humanaiinc.com</a><br />
          Website: <a href="https://www.humanaiinc.com" className="text-pink-400 hover:text-pink-300 underline">https://www.humanaiinc.com</a>
        </address>
      </section>
    </div>
  );
};

export default PrivacyPolicy; 